






























































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { IDocType } from "@/@types/admin/guest/user";
import { getBirthday } from "@/services/dateTime/getFullDate";

import identity_cards from "@/config/identity/identity_cards";

@Component({})
export default class ZItStaffData extends Vue {
  @Prop({ type: String, default: "" }) zit_surname!: string;
  @Prop({ type: String, default: "" }) zit_name!: string;
  @Prop({ type: String, default: "" }) zit_patronymic!: string;
  @Prop({ type: Date, default: null }) birthday!: Date | null;
  @Prop({ type: String, default: "" }) docType!: string;
  @Prop({ type: String, default: "" }) docNumber!: string;
  @Prop({ type: Number, default: 0 }) gender!: number;
  @Prop({ type: String, default: "" }) citizenship!: string;
  @Prop({ type: String, default: "" }) rank!: string;
  @Prop({ type: String, default: "" }) diploma!: string;

  get zitBirthdayDate(): string {
    if (!this.birthday) return "";
    return getBirthday(this.birthday);
  }

  get getDocument(): IDocType | null {
    const type = identity_cards.find((doc) => doc._id == this.docType);
    return type ? type : null;
  }
}
